<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
  >
    <ImageSlideCreateHeader
      :title="componentName"
      :instanceOptions="instanceOptions"
      :handleCreate="CreateInstance"
      :componentId="componentId"
    />
    <ImageSlideCreateForm
      :formData="formData"
      :allSlideAttributes="getAllAttributes"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import ImageSlideCreateForm from "@/components/ComponentModule/ImageSlideComponent/ImageSlideCreateForm";
import ImageSlideCreateHeader from "@/components/ComponentModule/ImageSlideComponent/ImageSlideCreateHeader";

export default {
  name: "ImageSlideCreatePage",
  components: {
    ImageSlideCreateHeader,
    ImageSlideCreateForm
  },
  data() {
    return {
      formData: { attributes: { hotspots: [] }, instance_name: "" }
    };
  },
  props: {
    componentId: {
      type: String,
      required: true
    }
  },
  async mounted() {
    await this.$store.dispatch(Actions.FETCH_COMPONENT_DATA, {
      region: this.getRegion,
      componentId: this.componentId
    });
  },
  computed: {
    componentName() {
      if (
        this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        )
      ) {
        return this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        ).name;
      } else {
        return "";
      }
    },
    instanceOptions() {
      const instanceList = [];
      if (this.getInstanceInfo) {
        this.getInstanceInfo.forEach((item) => {
          instanceList.push({
            value: item.id,
            label: item.instance_name.replace(`${this.componentId}_`, "")
          });
        });
      }
      return instanceList;
    },
    ...mapGetters([
      "getAllComponent",
      "getInstanceInfo",
      "getAllAttributes",
      "getRegion"
    ])
  },
  methods: {
    handleUpdateInstanceNum(val) {
      this.instance = val;
    },
    CreateInstance() {
      this.$store
        .dispatch(Actions.CREATE_COMPONENT_DATA, {
          formData: this.formData,
          region: this.getRegion,
          componentId: this.$route.params.compId
        })
        .then(() => {
          this.$router.push(`/component/${this.$route.params.compId}`);
        });
    }
  }
};
</script>
